export const interestAbbreviation = {
  baumagazin: {
    abbreviation: "bm",
    long_description:
      "Lesen Sie Nachrichten zu Bauwirtschaft und Baupolitik aus erster Hand. Plus: Hoch-, Tief- und Straßenbau.",
    short_description:
      "Bauwirtschaft und Baupolitik. Plus: Hoch-, Tief- und Straßenbau",
  },
  galabau: {
    abbreviation: "gb",
    long_description:
      "Werden Sie Experte im Garten- und Landschaftsbau. Plus: Kommunaltechnik.",
    short_description: "Garten- und Landschaftsbau",
  },
  umweltbau: {
    abbreviation: "ub",
    long_description:
      "Leitungsbau, Kanalsanierung, Abwasser – erfahren Sie das wichtigste rund ums Thema unterirdische Infrastruktur.",
    short_description:
      "Unterirdische Infrastruktur: Leitungsbau, Kanalsanierung und Co",
  },
  ausschreibungsdienste: {
    abbreviation: "ad",
    long_description:
      "Werden Sie Experte in Vergabefragen: Ausschreibungen, elektronische Vergabe und aktuelle Urteile zum Vergaberecht.",
    short_description:
      "Ausschreibungen, elektronische Vergabe und Vergaberecht",
  },
  evergabe: {
    abbreviation: "ad",
    long_description:
      "Werden Sie Experte in Vergabefragen: Ausschreibungen, elektronische Vergabe und aktuelle Urteile zum Vergaberecht.",
    short_description:
      "Ausschreibungen, elektronische Vergabe und Vergaberecht",
  },
}

export const getInterestData = ({ ressort }) =>
  interestAbbreviation[
    ressort in interestAbbreviation ? ressort : "ausschreibungsdienste"
  ]
// check for ressort, if evergabe -> take ausschreibungsdienste values,
// but keep ressort to have evergabe color displayed
